import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useDisclosure } from "@chakra-ui/react";
import React from "react";
import FormDao from "./Form";

const SendPropositionModal = ({ setisMutating }) => {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <Button className="btn-primary" width={'200px'} onClick={onOpen}>I have a proposition</Button>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent bg={'navy.800'}>
                    <ModalHeader>Create a proposition</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <FormDao setisMutating={setisMutating} edit={true} onClose={onClose} />
                    </ModalBody>
                </ModalContent>
            </Modal>            
        </>
    )
}

export default SendPropositionModal;